import { createAccessControl } from "better-auth/plugins/access";
import {
  defaultStatements,
  adminAc,
  ownerAc,
  memberAc,
} from "better-auth/plugins/organization/access";

const statement = {
  ...defaultStatements,
  invitation: ["create", "delete"],
} as const;

const ac = createAccessControl(statement);

const owner = ac.newRole({
  ...ownerAc.statements,
  invitation: ["create", "delete"],
});

const admin = ac.newRole({
  ...adminAc.statements,
  invitation: ["create", "delete"],
});
const member = ac.newRole({
  ...memberAc.statements,
  invitation: [],
});

export { ac, admin, owner, member };
